var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 7,
    viewBox: "0 0 336 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M5.5334 6.7132C5.5334 6.7132 3.99627 7.67042 3.53516 6.08735L2.15187 4.83561L0 3.95203V2.99483C2.98412 2.81409 6.01301 2.67882 9.06856 2.58985C16.9075 2.29533 31.5096 1.74309 58.5617 1.08041C75.3541 0.465597 92.2998 0.121216 109.285 0.0495748C109.285 0.0495748 162.467 -0.244959 216.878 0.601802C256.834 1.09136 296.621 2.18574 336 3.8784C336 3.8784 303.107 2.58985 269.138 1.74309C235.169 0.896332 199.663 0.380904 195.36 0.454536C195.36 0.454536 227.177 0.859517 260.069 1.74309C283.975 2.29784 307.734 3.17049 331.235 4.357C331.235 4.357 300.494 3.17891 268.831 2.40578C245.275 1.7165 221.544 1.43352 197.819 1.55902C197.819 1.55902 226.101 1.92717 255.919 2.77393C278.699 3.32606 301.33 4.18647 323.704 5.35103C323.704 5.35103 302.338 4.46745 296.498 4.43064L306.335 4.87242L290.349 4.43064L281.127 4.06247C281.127 4.06247 306.181 5.13014 307.872 5.42466C309.563 5.71919 310.792 5.42466 307.872 5.42466C304.951 5.42466 296.651 4.98287 273.749 4.50427C249.142 3.6708 224.354 3.17909 199.51 3.03164C134.478 2.50283 69.4056 3.73787 5.5334 6.7132Z",
    fill: "#11516D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrLine);
export default __webpack_public_path__ + "static/media/hrLine.19792db7.svg";
export { ForwardRef as ReactComponent };